import React from 'react'
import { MainWrap } from '../../utilities/Shared'
import { useState } from 'react'

const Unlink = () => {

const [job, setJob] = useState()


    const unlinkjob = () => {
console.log(job)
    }


  return (
    <MainWrap>
        <form onSubmit={unlinkjob}>
<div style={{marginTop:"30px",width:"40%"}}>

</div>
        <input type="text" onChange={e => setJob(e.target.value)}/>&nbsp;&nbsp;&nbsp;
        <button type="button">Unlink</button>
        </form>
    </MainWrap>
  )
}

export default Unlink